import { Component, Output, EventEmitter, OnInit } from '@angular/core';
import { AbstractMatTableComponent } from '@app/shared/base/abstract-mat-table/abstract-mat-table.component';

@Component({
  selector: 'app-onetimeservices-list-table',
  templateUrl: './onetimeservices-list-table.component.html',
  styleUrls: ['./onetimeservices-list-table.component.scss'],
})
export class OnetimeservicesListTableComponent
  extends AbstractMatTableComponent
  implements OnInit
{
  @Output() openWorkOrderDetail = new EventEmitter<{
    workOrderId: string;
  }>();

  displayedColumns: string[] = [
    'serviceAccountName',
    'requestType',
    'workOrderNumber',
    'serviceDetails',
    'confirmedServiceDate',
    'systemStatus',
    'action',
  ];

  constructor() {
    super();
  }
  ngOnInit(): void {
    super.ngOnInit();
  }
  workOrderSelected(workOrderId: string) {
    this.openWorkOrderDetail.emit({ workOrderId });
  }
}
